module.exports = __webpack_public_path__ + "img/red-pita-06.43524ace.png";